import type { AccountResponse } from '@shared/api/rest/accounts';
import type { RecipientResponse } from '@shared/api/rest/recipients';
import type { TransferRequestResponse } from '@shared/api/rest/transferRequests';
import { PaymentModal } from '../modal/paymentModal';
import { OTPModal } from '../modal/otpModal';
import { ConfirmModal } from '../modal/confirmModal';
import AlertIcon from '@assets/icons/alert.svg';
import ConfirmIcon from '@assets/icons/confirm.svg';
import { useUnit } from 'effector-react';
import { $transferUpdateStatusStore } from '@lib/store';
import { ApiResponse } from '@shared/api/models';

interface TransferConfirmationBlockProps {
  modal: boolean;
  error?: string;
  confirmModal: boolean;
  account: AccountResponse;
  recipient?: RecipientResponse | null;
  otpModal: TransferRequestResponse | null;
  transactionId?: string;
  amountVal?: number;
  fee?: number;
  reason: string;
  purpose?: string;
  exchangeRate?: number;
  isFastPayment?: boolean;
  openConfirmModal: () => void;
  closeOTPModal: () => void;
  closeModal: () => void;
  onDocumentsConfirm: () => void;
  accountTo?: AccountResponse;
  transferRequest?: ApiResponse<TransferRequestResponse>;
}

export const TransferConfirmationBlock = (props: TransferConfirmationBlockProps) => {
  const updateStatusStore = useUnit($transferUpdateStatusStore.store);
  return (
    <>
      <PaymentModal
        account={props.account!}
        recipient={props.recipient}
        transactionId={props.transactionId}
        amount={props.amountVal!}
        fee={props.fee}
        reason={props.reason}
        purpose={props.purpose!}
        exchangeRate={props.exchangeRate}
        isFastPayment={props.isFastPayment!}
        onConfirm={props.onDocumentsConfirm}
        onClose={props.closeModal}
        accountTo={props.accountTo}
        isOpen={props.modal}
        transferRequest={props.transferRequest}
      />

      {props.otpModal && <OTPModal onClose={props.closeOTPModal} data={props.otpModal} onSubmit={props.openConfirmModal} />}
      {props.confirmModal && (
        <ConfirmModal
          title={props.error === 'error' ? (updateStatusStore.error ?? 'Something went wrong') : 'Transfer request has been created'}
          icon={props.error === 'error' ? <AlertIcon /> : <ConfirmIcon />}
        />
      )}
    </>
  );
};
